export default __webpack_public_path__ + "_/images/promo_action/instructions/image4-d27e8dc1841d843cb6571855739f226bffa7af88752ec9589a86ccd6613901f4.png";